"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrowDownOutline = {
    name: 'arrow-down',
    theme: 'outline',
    nameWithTheme: 'arrow-down-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861c12.7 14.7 35.5 14.7 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'
            },
            children: []
        }
    ]
};
exports.default = ArrowDownOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/outline/ArrowDownOutline.js
// module id = 859
// module chunks = 0 1